/* 更新履歴 */
import React, { memo } from 'react';
import { update_history_init } from '../../Const';
var UpdateHistory = function (_a) {
    var history = _a.history, t = _a.t;
    var history_list = history !== null ? history : update_history_init;
    return (React.createElement("div", { className: "my-2" },
        React.createElement("div", { className: "col-md-12 col-sm-12 update-history-list" }, history_list.map(function (item, index) { return (React.createElement("dl", { key: index },
            React.createElement("dt", null, t(item.key)),
            React.createElement("dd", null, item.value))); }))));
};
export default memo(UpdateHistory);
